import React from 'react';
import { Card, Tabs, Typography, Space } from 'antd';
import BeastTab from './BeastTab';
import ItemTab from './ItemTab';
import './index.less';

const { Title } = Typography;

const DinosaurAdmin: React.FC = () => {
  const items = [
    { key: 'beast', label: '🦖 Dinosaur', children: <BeastTab /> },
    { key: 'item', label: '📦 食物', children: <ItemTab /> },
  ];

  return (
    <div className="dinosaur-admin">
      <Card
        title={
          <Space>
            <Title level={4} style={{ margin: 0 }}>Dinosaur 管理</Title>
          </Space>
        }
        bodyStyle={{ padding: 0 }}
      >
        <Tabs
          defaultActiveKey="beast"
          items={items}
          tabBarStyle={{ paddingLeft: 16, marginBottom: 0 }}
        />
      </Card>
    </div>
  );
};

export default DinosaurAdmin;
